export default "Pekné, útulné ubytovanie vhodné na prespatie pre pár alebo jedného. Dokonalo čisté.";